const listeners = new Set();

export const emitFive9CallLifecycleEvent = (type, payload) => {
  listeners.forEach((listener) => {
    try {
      listener({ type, payload });
    } catch (_) {
      // SDK callbacks must remain non-blocking even if a consumer fails.
    }
  });
};

export const subscribeToFive9CallLifecycleEvents = (listener) => {
  listeners.add(listener);
  return () => listeners.delete(listener);
};
